import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SmIcon from '@/components/ui/SmIcon/SmIcon.vue';

import '@/components/ui/preloaders/DefaultPreloader/style.scss';

export default /*#__PURE__*/_defineComponent({
  __name: 'DefaultPreloader',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SmIcon, {
    name: "loader",
    class: "default-preloader"
  }))
}
}

})